// extracted by mini-css-extract-plugin
export default {"bookingStatus":"BookingStatus_bookingStatus__W8G06"};